module.exports = __webpack_public_path__ + "img/logo.59e470f1.png";